module.exports = __webpack_public_path__ + "static/media/downloadd.193f684a.gif";